import * as React from 'react';
import { useOrder, createContainsHelper } from '@grandvisionhq/fun-orders';
import { useCartStorage } from '@grandvisionhq/lib-utils-cart';
import { useIntl } from '@grandvisionhq/state';
import { pushPurchaseEventToDataLayer, trackOrderCompletionEvents } from '../data-layer.js';
import { useOrderConfirmLabels } from './hooks/use-order-confirm-labels.js';
import { useOrderConfirmTealiumEvent } from './hooks/use-order-confirm-tealium-event.js';
import { OrderConfirm } from './OrderConfirm.js';

const OrderConfirmContainerV2 = ({ logo , orderData: orderToken , cartId , enableTrustedShopsCheckout , expressOrder =false  })=>{
    const [, { reset  }] = useCartStorage();
    const { getOrderByToken , order , error , loading , onCompleted  } = useOrder();
    const { handleOrderConfirmPageEventDispatch  } = useOrderConfirmTealiumEvent();
    const labels = useOrderConfirmLabels(order);
    const { currency  } = useIntl();
    const contains = React.useMemo(()=>{
        return createContainsHelper(order === null || order === void 0 ? void 0 : order.lineItems);
    }, [
        order === null || order === void 0 ? void 0 : order.lineItems
    ]);
    React.useEffect(()=>{
        if (orderToken) {
            getOrderByToken(orderToken);
        }
    // Only `orderToken` needed in the dep. array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        orderToken
    ]);
    React.useEffect(()=>{
        onCompleted(()=>{
            // Reset Cart when order data has been fetched successfully
            reset();
        });
    }, [
        onCompleted,
        reset
    ]);
    React.useEffect(()=>{
        if (order) {
            var ref;
            if (order.donationIntent && ((ref = order.donation) === null || ref === void 0 ? void 0 : ref.amount)) {
                pushPurchaseEventToDataLayer(order, currency, cartId, expressOrder, {
                    foundationKey: order.donationIntent.foundationKey,
                    centAmount: order.donation.amount
                });
            } else {
                pushPurchaseEventToDataLayer(order, currency, cartId, expressOrder);
            }
            trackOrderCompletionEvents(order, currency);
            handleOrderConfirmPageEventDispatch(order);
        }
    }, [
        cartId,
        currency,
        order,
        handleOrderConfirmPageEventDispatch,
        expressOrder
    ]);
    return /*#__PURE__*/ React.createElement(OrderConfirm, {
        order: order,
        logo: logo,
        labels: labels,
        contains: contains,
        error: error,
        isLoading: loading,
        enableTrustedShopsCheckout: enableTrustedShopsCheckout
    });
};

export { OrderConfirmContainerV2 };
//# sourceMappingURL=OrderConfirmContainerV2.js.map
